import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, BehaviorSubject, from } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AlertController, Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { switchMap, map, take, tap } from 'rxjs/operators';
import { SERVER_URL, PATIENT_URL, LOOKUP_URL } from 'src/config';
import { Storage } from '@ionic/storage';

import { SwasthStorageService } from '../storage/swasth-storage.service';
import { WebsocketService } from "../services/websocket.service";

const helper = new JwtHelperService();
const TOKEN_KEY = "jwt-tokenp";

@Injectable({
  providedIn: 'root'
})
export class LoginAuthService {

  LOGINUSER_PROFILE = "pprofile";
  token = '';

  public user: Observable<any>;
  private userData = new BehaviorSubject(null);
  private loginUserProfile = new BehaviorSubject(null);
  
  constructor(private storage: Storage, private http: HttpClient, private plt: Platform,
    private router: Router, private swasthStorage: SwasthStorageService, private alertCtrl: AlertController,
    private webSocket : WebsocketService) {
      this.loadStoredToken();
  }

  loadStoredToken() {
    // console.log("init token from storage");
    let platformObs = from (this.plt.ready());
    // console.log("init token from storagevvvvvvvvvv");
    this.user = platformObs.pipe(
      switchMap(() => {
        return from(this.storage.get(TOKEN_KEY))            
      }),
      map(token => {
        // console.log("token from storage", token);
        if(token) {    
          if(!helper.isTokenExpired(token)) {
            let decoded = helper.decodeToken(token);
            // console.log('decoded: ', decoded);
            this.userData.next(decoded);  
            this.webSocket.subcribe(decoded.UID,false);  
            // console.log("trueeeeeeeee");
            return true;
          } else {
            return null;
          }        
                            
        } else {
          // console.log("falseeeeeeeee");
          return null;
        } 
      })
    );
  }

  // user session login 
  login(values: any,rememberValues:any): Observable<any> {
    return this.http.post(`${SERVER_URL}/circlelogin`, values, {responseType: 'text'}).pipe(
      take(1),
      map(token => {
      if(token !== 'NOTEXISTS'){
        /* if(rememberValues==1)
        {
          return this.handleJwtResponse(jwt);
        } */     
        
        return token;
      } else if(token == 'NOTEXISTS') {
        this.alertFn();
      }else {
        alert("user not exists");
      }      
    }),
    switchMap(token => {
      let decoded:any = helper.decodeToken(token);
      // console.log('decoded: ', decoded);
      this.userData.next(decoded);
      this.webSocket.subcribe(decoded.UID,true);
      // let storageObs:any;
      let storageObs = from(this.storage.set(TOKEN_KEY, token));
      return storageObs;
    })
    );
  }

  otpLogin(values): Observable<any> {
    return this.http.post(`${SERVER_URL}/loginotp`, values, {responseType: 'text'}).pipe(
      take(1),
      switchMap(token => {
        if(token !== 'NOTEXISTS'){     
          this.token = token;
          let decodedToken = helper.decodeToken(this.token);
          this.webSocket.subcribe(decodedToken.UID,true);
          this.userData.next(decodedToken);
          return from(this.storage.set(TOKEN_KEY, token));
        } else if(token == 'NOTEXISTS') {
          this.showToast();
        }else {
          alert("user not exists");
        }        
      }),
      tap(_ => {
        // this.isAuthenticated.next(true);
        // this.isRemember.next(true);
      })
    );
  }

  // user session login 
  corporatelogin(values: any,rememberValues:any): Observable<any> {
    //console.log("dssdsdds",values);
    return this.http.post(`${SERVER_URL}/circlecorporatelogin`, values, {responseType: 'text'}).pipe(
      take(1),
      map(token => {
      if(token !== 'NOTEXISTS'){
        /* if(rememberValues==1)
        {
          return this.handleJwtResponse(jwt);
        } */     
        
        return token;
      } else if(token == 'NOTEXISTS') {
        this.alertFn();
      }else {
        alert("user not exists");
      }      
    }),
    switchMap(token => {
      let decoded:any = helper.decodeToken(token);
      // console.log('decoded: ', decoded);
      this.userData.next(decoded);      
      this.webSocket.subcribe(decoded.UID,true);
      let storageObs = from(this.storage.set(TOKEN_KEY, token));

      return storageObs;
    })
    );
  }

  getUser() {
    return this.userData.getValue();
  }

  getUserApi(uid) {
    // console.log("user id", uid);
    return this.http.get(`${LOOKUP_URL}/scgetcirclepatientdetailssc/`+uid, {responseType: "json"});      
  }

  getUserdetail() {
    /* console.log("after set",this.loginUserProfile.getValue());
    return this.loginUserProfile.getValue(); */
    this.storage.get(this.LOGINUSER_PROFILE).then(data=>{
      // console.log("storage profile----->",data);
      if(data != undefined) {
        return data;
      } else {
        return null;
      }
      
    });
  }

  logout() {
    // this.swasthStorage.clearStorage();
    //   this.storage.clear();
    //   localStorage.clear();
    //   window.location.href='';
    //   //this.router.navigateByUrl('login']); 
    this.storage.remove(TOKEN_KEY).then(() => {
      this.swasthStorage.clearStorage();
      this.storage.clear();
      localStorage.clear();      
      
      this.swasthStorage.removeStorage(this.LOGINUSER_PROFILE);
      this.swasthStorage.removeStorage("UPDATEDCIRCLELIST");
      this.userData.next(null);
      this.webSocket.ngOnDestroy();
      //window.location.href='';
      // this.router.navigateByUrl('/login');      
      this.router.navigateByUrl('/home');        
    })
  }

  async alertFn() {
    const alert = await this.alertCtrl.create({
      header: 'Login Failed',
      message: 'Invalid Mobile Number',
      buttons: ['ok']
    });
    await alert.present();
  }

  private async showToast() {
    // console.log("Response Message======"+data);      
    const alert = await this.alertCtrl.create({
      header: 'Login Failed',
      message: 'Invalid User ID',
      buttons: ['ok']
    });
    await alert.present();
  }
}
